module.exports = __webpack_public_path__ + "static/media/provider4@2x.233e58b3.png";